module.exports = __webpack_public_path__ + "static/media/ic_template_8.f22f141b.png";